/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_Extra_Point_3_TextInputs */

const en_visa_e2_extra_point_3_text = /** @type {(inputs: Visa_E2_Extra_Point_3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We help clients assess not only the initial filing, but also how the visa strategy fits into their broader U.S. business or immigration goals.`)
};

const pt_visa_e2_extra_point_3_text = /** @type {(inputs: Visa_E2_Extra_Point_3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajudamos os clientes a avaliar não apenas a apresentação inicial, mas também como a estratégia de visto se encaixa em seus objetivos mais amplos de negócios ou imigração nos EUA.`)
};

const es_visa_e2_extra_point_3_text = /** @type {(inputs: Visa_E2_Extra_Point_3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayudamos a los clientes a evaluar no solo la presentación inicial, sino también cómo la estrategia de visa se integra en sus objetivos más amplios de negocios o inmigración en EE. UU.`)
};

/**
* | output |
* | --- |
* | "We help clients assess not only the initial filing, but also how the visa strategy fits into their broader U.S. business or immigration goals." |
*
* @param {Visa_E2_Extra_Point_3_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_extra_point_3_text = /** @type {((inputs?: Visa_E2_Extra_Point_3_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_Extra_Point_3_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_extra_point_3_text(inputs)
	if (locale === "es") return es_visa_e2_extra_point_3_text(inputs)
	return en_visa_e2_extra_point_3_text(inputs)
});